export default __webpack_public_path__ + "static/media/cert-general2024-cpttm.a1b1a4ec.jpg";